export const token_addresses = {
  emojiFlagAddress:"0xA491F2133fbb0D5Caa2645532FB740ad8B3F2D51"
}
